/**
 * BusinessInfoSection Component
 * 협력사 사업자 정보 입력/수정 섹션
 */
import React from 'react';
import { SupplierInfo } from '../types/supplierInfo.types';
import { SaveIcon } from '@/shared/components/icons/Icons';

interface BusinessInfoSectionProps {
    supplierInfo: SupplierInfo;
    saving: boolean;
    onFieldChange: (field: keyof SupplierInfo, value: string) => void;
    onSave: () => void;
}

const BusinessInfoSection: React.FC<BusinessInfoSectionProps> = ({
    supplierInfo,
    saving,
    onFieldChange,
    onSave
}) => {
    return (
        <div className="supplier-section">
            <h2 className="section-title">사업자 정보</h2>
            
            {/* 첫 번째 줄: 법인명, 사업자등록번호, 대표자명 */}
            <div className="supplier-form-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
                <div className="form-group">
                    <label className="form-label">법인명:</label>
                    <input
                        type="text"
                        className="form-input"
                        value={supplierInfo.companyName}
                        onChange={(e) => onFieldChange('companyName', e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">사업자등록번호:</label>
                    <input
                        type="text"
                        className="form-input"
                        value={supplierInfo.businessNumber}
                        onChange={(e) => onFieldChange('businessNumber', e.target.value)}
                        placeholder="0000000000"
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">대표자명:</label>
                    <input
                        type="text"
                        className="form-input"
                        value={supplierInfo.representative}
                        onChange={(e) => onFieldChange('representative', e.target.value)}
                    />
                </div>
            </div>

            {/* 두 번째 줄: 업태, 종목, 사업자종류, 과세자 */}
            <div className="supplier-form-grid" style={{ marginTop: 'var(--spacing-4)', gridTemplateColumns: 'repeat(4, 1fr)' }}>
                <div className="form-group">
                    <label className="form-label">업태:</label>
                    <input
                        type="text"
                        className="form-input"
                        value={supplierInfo.bizType}
                        onChange={(e) => onFieldChange('bizType', e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">종목:</label>
                    <input
                        type="text"
                        className="form-input"
                        value={supplierInfo.bizItem}
                        onChange={(e) => onFieldChange('bizItem', e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">사업자종류:</label>
                    <select
                        className="form-select"
                        value={supplierInfo.bizClass}
                        onChange={(e) => onFieldChange('bizClass', e.target.value)}
                    >
                        <option value="">선택</option>
                        <option value="일반">일반</option>
                        <option value="법인">법인</option>
                    </select>
                </div>

                <div className="form-group">
                    <label className="form-label">과세자:</label>
                    <select
                        className="form-select"
                        value={supplierInfo.taxType}
                        onChange={(e) => onFieldChange('taxType', e.target.value)}
                    >
                        <option value="">선택</option>
                        <option value="GENERAL">일반과세자</option>
                        <option value="SIMPLIFIED">간이과세자</option>
                        <option value="EXEMPT">면세사업자</option>
                    </select>
                </div>
            </div>

            {/* 저장 버튼 */}
            <div className="section-actions">
                <button
                    className="btn btn-primary"
                    onClick={onSave}
                    disabled={saving}
                >
                    <SaveIcon width={16} height={16} />
                    <span>{saving ? '저장 중...' : '저장'}</span>
                </button>
            </div>
        </div>
    );
};

export default BusinessInfoSection;
